import { useGlobalStore } from '@/frontend/store/GlobalStore';
import { I18n } from '@/i18n/I18n';
import { FileParams, FileSubjectTypes } from '@/types/fileTypes';
import { UpdatedParamsAndRefs } from '@/types/parameterTypes';
import { FileDragAndDrop } from './FileDragAndDrop';
import { FileWithDisplay } from './FileWithDisplay';
import { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { File as FileModel } from '@/backend/models/file';
import { FileUploadWrapper } from './FileUploadWrapper';

function getValidFileType(fileType?: string) {
  switch (fileType) {
    case 'image':
      return 'image/*';
    case 'video':
      return 'video/*';
    default:
      return '';
  }
}

export function FileDragAndDropWithDisplay(props: { file?: FileParams, subjectId: string, subjectType: FileSubjectTypes, refetchSubject: (updatedConsumers: UpdatedParamsAndRefs) => void, fileType?: string }) {
  const { file, subjectId, subjectType, refetchSubject, fileType } = props;
  const replaceFile = useGlobalStore(state => state.replaceFile);
  const replaceFileInputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const validFileType = getValidFileType(fileType);

  const handleReplaceFile = async (fileToUpload?: File) => {
    if(!fileToUpload) return;
    setUploading(true);
    try {
      await replaceFile({ fileName: fileToUpload.name, subjectId, subjectType }, fileToUpload, refetchSubject, setUploadProgress);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (!file) {
    return <FileDragAndDrop
      setFile={(fileToUpload) => void handleReplaceFile(fileToUpload)}
      accept={validFileType}
      uploading={uploading}
      uploadProgress={uploadProgress}
    />;
  }

  return (
    <FileUploadWrapper uploading={uploading} uploadProgress={uploadProgress}>
      <div className="mb-3 d-flex gap-2 align-items-end">
        <div style={{ maxWidth: '350px' }}>
          <FileWithDisplay file={new FileModel(file)} hideFilePreview={false} />
        </div>

        <div style={{ maxWidth: '180px' }}>
          {file.fileName}
          <input
            ref={replaceFileInputRef}
            type="file"
            className="d-none"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => void handleReplaceFile(event.target.files?.[0])}
            accept={validFileType}
            aria-label={I18n.get('replaceFileType', { type: I18n.get(fileType || 'file') })}
          />
          <Button className="btn-blue-light fusa-btn-small" onClick={() => replaceFileInputRef.current?.click()}>
            {I18n.get('replaceFileType', { type: I18n.get(fileType || 'file') })}
          </Button>
        </div>
      </div>
    </FileUploadWrapper>
  );
}
